import { Dialog, type DialogProps } from '@mui/material'
import { styled } from '@mui/material/styles'
import { youShallNotPass } from 'lib/helpers/youShallNotPass/youShallNotPass'
import * as tkn from './Modal.tokens'
import type { ModalSize, ModalProps } from './Modal.types'

export const MODAL_SIZES: Record<ModalSize, string> = {
  s: tkn.ModalSizeWidthSmall,
  m: tkn.ModalSizeWidthMedium,
  l: tkn.ModalSizeWidthLarge,
  xl: tkn.ModalSizeWidthXlarge,
  xxl: '1440px',
  settings: '1110px',
  upsell: '886px',
}

interface StyledModalProps extends DialogProps {
  placement?: ModalProps['placement']
}

export const Modal = styled(Dialog, {
  shouldForwardProp: youShallNotPass('placement', 'size'),
})<StyledModalProps>(({ placement, theme }) => ({
  zIndex: theme.zIndexes.dialog,
  '& .MuiBackdrop-root': {
    background: 'rgba(0, 0, 0, 0.3)',
  },
  '& .MuiDialog-container': {
    ...(placement === 'top' && {
      alignItems: 'flex-start',
    }),
  },
}))
